import QuestionManager from "../../../components/JobDescription/QuestionManager";
import Blob from "../../../components/common/Blob";

function JEQuestions() {
    return <QuestionManager />;
}

export default JEQuestions;
